import React, { useEffect, useState } from "react";
import * as FaIcons from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import Multiselect from "multiselect-react-dropdown";
import swal from "sweetalert";
import { get_ApiManager, post_ApiManager } from "../ApiManager/ApiManager";
import "../Providers/provider.css";
import InternalMeetingModel from "../MeetingNotes/InternalNotes";

const Title = (props) => {
  const history = useNavigate();
  const [selectedBranches, setSelectedBranches] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [addMeeting, setAddMeeting] = useState(false);

  useEffect(() => {
    if (props.showBranches) {
      getAllowedBranches();
      getSelectedBranches();
    }
  }, []);

  const getSelectedBranches = () => {
    const data = "";
    let url = "getSelectedBranches";
    get_ApiManager(
      data,
      url,
      (res) => {
        console.log("selected-branches", res);
        setSelectedBranches(res.data.data);
      },
      (err) => {
        throw err;
      },
    );
  };

  const getAllowedBranches = () => {
    const data = "";
    let url = "getAllowedBranches";
    get_ApiManager(
      data,
      url,
      (res) => {
        console.log("branches", res);
        setBranchList(res.data.data);
      },
      (err) => {
        throw err;
      },
    );
  };

  const onRemove = (selectedList, selectedItem) => {
    submitBranches(selectedItem);
  };
  const onSelect = (selectedList, selectedItem) => {
    submitBranches(selectedItem);
  };
  const submitBranches = (branches) => {
    let url = "saveBranches";
    const data = {
      branches: branches,
    };
    console.log(data);
    post_ApiManager(
      data,
      url,
      (res) => {
        console.log("saved-branches", res);
        if (res.data.error) swal(" ", res.data.error, "error");
        else {
          getSelectedBranches();
          props.parentCallback();
        }
      },
      (err) => {
        console.log(err);
      },
    );
  };
  const handleCallback = () => {
    props.parentCallback();
    setAddMeeting(false);
  };

  const myTasksButton = props.showMyTasks ? (
    <Link to="/my-tasks" className="text-decoration-none">
      <button
        type="button"
        className={
          props.tailwindActions
            ? "inline-flex items-center gap-2 rounded-lg border border-[#007BFF] bg-[#007BFF] px-3 py-2 text-[0.8125rem] font-semibold text-white shadow-sm transition hover:border-blue-600 hover:bg-blue-600 whitespace-nowrap"
            : "btn btn-primary white fira-font d-inline-flex align-items-center gap-2 px-3 py-2 shadow-sm"
        }
        style={
          props.tailwindActions
            ? undefined
            : {
                fontSize: "0.8125rem",
                fontWeight: 600,
                borderRadius: "8px",
                whiteSpace: "nowrap",
              }
        }
      >
        <FaIcons.FaClipboardList size={14} />
        <span>My Tasks</span>
      </button>
    </Link>
  ) : null;

  const branchMultiselect = props.showBranches ? (
    <div
      className="dashboard-title-branches"
      style={{ flex: "1 1 12rem", minWidth: "10rem", maxWidth: "22rem" }}
    >
      <Multiselect
        options={branchList
          .slice()
          .sort((a, b) => a.agencyname.localeCompare(b.agencyname))}
        className={`${
          props.branchInnerClass
            ? `${props.branchInnerClass} form-select chip-hide s-dropdown py-1 shadow-sm`
            : "form-select chip-hide s-dropdown py-1 shadow-sm"
        }`}
        placeholder={"Select Branch/s"}
        displayValue={"agencyname"}
        onSelect={onSelect}
        showCheckbox={true}
        disablePreSelectedValues={false}
        hidePlaceholder={false}
        onRemove={onRemove}
        selectedValues={selectedBranches}
      />
    </div>
  ) : null;

  return (
    <>
      {props.back && !props.btn ? (
        <div className="p-1">
          <div className={`row pr-3 ${props.flushLeft ? "pl-1" : "pl-3"}`}>
            <div className={props.titleCol || "col-lg-4"}>
              {props.inlineBackTitle ? (
                <div
                  className={`d-flex flex-wrap align-items-center gap-2 pt-1 ${props.flushLeft ? "" : "pl-lg-2"}`}
                >
                  <a
                    className="back-icon d-inline-flex align-items-center shrink-0"
                    onClick={() =>
                      props.backUrl ? history("/main-settings") : history(-1)
                    }
                  >
                    <FaIcons.FaArrowAltCircleLeft size={20} />
                    <small className="back-text ps-1">back</small>
                  </a>
                  {!props.hideTitle && props.title && (
                    <h4 className="text-left custom-font4 bold mb-0">
                      {props.title}
                    </h4>
                  )}
                </div>
              ) : (
                <>
                  <span className="block pb-1 pt-0">
                    <a
                      className={`back-icon ${props.flushLeft ? "" : "pl-lg-2"}`}
                      onClick={() =>
                        props.backUrl ? history("/main-settings") : history(-1)
                      }
                    >
                      <FaIcons.FaArrowAltCircleLeft size={20} />
                      <small className={`back-text ${props.flushLeft ? "" : "pl-lg-1"}`}>back</small>
                    </a>
                  </span>
                  {!props.hideTitle && props.title && (
                    <h4 className={`text-left custom-font4 bold mb-0 pt-2 ${props.flushLeft ? "" : "pl-lg-2"}`}>
                      {props.title}
                    </h4>
                  )}
                </>
              )}
            </div>

            {props.headerAction && (
              <div className={`col-lg-auto ms-lg-auto ${props.flushLeft ? "pl-2" : ""}`}>
                <div className="tailwind-container d-flex align-items-center pt-2">
                  {props.headerAction}
                </div>
              </div>
            )}

            {props.showBranches && (
              <div className="col-lg-3 col-5">
                <Multiselect
                  options={branchList
                    .slice()
                    .sort((a, b) => a.agencyname.localeCompare(b.agencyname))}
                  className="form-select float-right chip-hide s-dropdown py-1 shadow-sm"
                  placeholder={"Select Branch/s"}
                  displayValue={"agencyname"}
                  onSelect={onSelect}
                  showCheckbox={true}
                  disablePreSelectedValues={false}
                  hidePlaceholder={false}
                  onRemove={onRemove}
                  selectedValues={selectedBranches}
                />
                {/* <select className="form-select app-form float-right" onChange={(e) => props.parentCallback(e.target.value)}>
        <option selected value={'null'}>Select Branch</option>
        {[].concat(props.showBranches).sort((a, b) => a.agencyname > b.agencyname ? 1 : -1).map(value =>
        <option key={value.id} className="light" value={value.id}>{value.agencyname}</option> )}
        </select>  */}
              </div>
            )}
            {props.showTask && (
              <div
                className={`${props.taskClass ? props.taskClass : "col-lg-2 pt-1"}`}
              >
                <Link to={`/task-report`}>
                  <button className="btn btn-warning white w-100 fira-font">
                    Progress Report
                    <FaIcons.FaRegCalendarAlt size={15} />
                  </button>
                </Link>
              </div>
            )}

            {props.addMeeting && (
              <div
                onClick={() => setAddMeeting(true)}
                className={`${props.meetingClass ? props.meetingClass : "col-lg-2 pt-1"}`}
              >
                <button className="btn btn-success white w-100 fira-font">
                  Create Meeting Notes
                  <FaIcons.FaRegAddressCard
                    className="ms-1"
                    size={15}
                    parentCallback={handleCallback}
                  />
                </button>
              </div>
            )}
            <InternalMeetingModel
              show={addMeeting}
              parentCallback={handleCallback}
            />
          </div>
        </div>
      ) : props.singleRowHeader ? (
        <div className="px-1 py-1">
          <div
            className="d-flex flex-wrap align-items-center w-100 gap-2"
            style={{ rowGap: "0.5rem" }}
          >
            <h4 className="mb-0 text-left custom-font4 bold shrink-0">{props.title}</h4>
            <div
              className="d-flex flex-wrap align-items-center justify-content-end gap-2 ms-auto"
              style={{ flex: "1 1 20rem", minWidth: 0 }}
            >
              {props.headerExtra}
              {myTasksButton}
              {branchMultiselect}
            </div>
          </div>
        </div>
      ) : (
        <div className="p-1">
          <div className="row pr-2">
            {props.back && (
              <span className="pt-0 col-11">
                <a
                  className="back-icon pl-lg-2"
                  onClick={() =>
                    props.backUrl ? history("/main-settings") : history(-1)
                  }
                >
                  <FaIcons.FaArrowAltCircleLeft size={20} />
                  <span className="back-text pl-lg-1">back</span>
                </a>
              </span>
            )}
            <h4
              className={`text-left custom-font4 bold ${
                !props.back
                  ? "pt-1 pl-1"
                  : props.flushLeft
                    ? ""
                    : " pl-lg-3"
              } ${props.titleCol ? props.titleCol : "col-lg-4"}`}
            >
              {props.title}
            </h4>
            {props.headerAction && (
              <div className={`col-lg-auto ms-lg-auto ${props.flushLeft ? "pl-2" : ""}`}>
                <div className="tailwind-container d-flex align-items-center pt-1">
                  {props.headerAction}
                </div>
              </div>
            )}
            {props.btn ? (
              <div className={`${props.btnCol ? props.btnCol : "col-lg-6"}`}>
                <button
                  type="button"
                  onClick={() =>
                    props.btnUrl
                      ? history(props.btnUrl)
                      : props.parentCallback()
                  }
                  className={`${props.btnClass ? props.btnClass : ""}`}
                >
                  {props.btnText}
                </button>
              </div>
            ) : (
              ""
            )}

            {/* <div className="col-lg-2 pt-1">
              <Link to={`/walkin-clients`}>
                <button className="btn btn-primary white w-100 fira-font">
                  Walk-in Clients
                  <FaIcons.FaRegCalendarAlt size={15} />
                </button>
              </Link>
            </div> */}

            {props.showMyTasks && (
              <div
                className={
                  props.taskButtonsClass ||
                  props.taskMgmtClass ||
                  "col-lg-auto col-md-auto pt-1 ms-lg-auto"
                }
              >
                <div className="d-flex flex-wrap align-items-center justify-content-md-end gap-2">
                  {myTasksButton}
                </div>
              </div>
            )}

            {props.showTask && (
              <div
                className={`${props.taskClass ? props.taskClass : "col-lg-2 pt-1"}`}
              >
                <Link to={`/task-report`}>
                  <button className="btn btn-warning white w-100 fira-font">
                    Progress Report
                    <FaIcons.FaRegCalendarAlt className="ms-1" size={15} />
                  </button>
                </Link>
              </div>
            )}

            {props.showMeeting && (
              <div
                className={`${props.meetingClass ? props.meetingClass : "col-lg-2 pt-1"}`}
              >
                <Link to={`/view-internal-notes`}>
                  <button className="btn btn-danger white w-100 fira-font">
                    Meeting Notes
                    <FaIcons.FaRegAddressCard className="ms-1" size={15} />
                  </button>
                </Link>
              </div>
            )}

            {props.showBranches && (
              <div
                className={`${props.branchClass ? props.branchClass : "col-lg-8 pt-1"}`}
              >
                {branchMultiselect}
              </div>
            )}
            {/* <div className={`${props.branchClass ? props.branchClass : 'col-lg-8 pt-1'}`}>
            <select className={`${props.branchInnerClass ? props.branchInnerClass+ ' form-select app-form float-right ' : 'form-select app-form float-right'}`}
             onChange={(e) => props.parentCallback(e.target.value)}>
            <option selected value={'null'}>Select Branch</option>
            {[].concat(props.showBranches).sort((a, b) => a.agencyname > b.agencyname ? 1 : -1).map(value =>
            <option key={value.id} className="light" value={value.id}>{value.agencyname}</option> )}
            </select> 
            </div>} */}
          </div>
        </div>
      )}
    </>
  );
};
export default Title;
